
<template>
  <div class="pb-4">
    <van-nav-bar
      title="选择分馆"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <div class="p-2">
      <div class="mt-1">
        <span class="middle-text font-semibold text-gray-500">分馆</span>
        <div
          class="
            mt-1
            grid grid-cols-2
            justify-evenly
            items-center
            gap-1
            middle-text
          "
        >
          <div
            v-for="lib in libraries"
            :key="lib.id"
            class="
              whitespace-nowrap
              leading-5
              rounded
              text-center
              shadow-md
              bg-white
            "
            :class="{
              selected: lib.id === library.id,
            }"
            @click="selectLibrary(lib)"
          >
            <span>{{ lib.name }}</span>
          </div>
        </div>
      </div>
      <p class="mt-2 middle-text font-semibold text-gray-500">日期</p>
      <div class="flex justify-center space-x-1">
        <van-button
          class="shadow-md"
          round
          plain
          v-for="sday in days"
          :key="sday"
          :class="{ selected: sday === day }"
          @click="selectDay(sday)"
          ><span class="whitespace-nowrap">{{ sday }}</span></van-button
        >
      </div>
    </div>
    <van-notice-bar left-icon="volume-o" text="入馆规则" @click="showRules" />
    <div
      v-for="ent in entrances"
      :key="ent.id"
      class="m-2 p-1 middle-text rounded text-center border shadow-md bg-white"
      :class="{ selected: ent.id === entrance.id }"
      @click="selectEntrance(ent)"
    >
      <p>剩余：{{ ent.available }}</p>
      <p>时间：{{ ent.starttime.slice(6) + "~" + ent.endingtime.slice(6) }}</p>
    </div>
    <van-row class="fixed left-0 bottom-0 w-full bg-white small-text">
      <van-col span="6">
        <div class="text-center" @click="refresh">
          <van-icon name="replay" />
          <span class="block">刷新</span>
        </div>
      </van-col>
      <van-col span="18">
        <van-button
          :disabled="availables < 1"
          block
          size="large"
          color="#49cfd4"
          @click="applyNow"
          >马上预约</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import {
  getEntranceSchools,
  getEntranceDates,
  getEntrances,
  applyEntrance,
} from "@/service/home";
import Cookies from "js-cookie";
import { Toast, Dialog } from "vant";
import qs from "qs";
export default {
  name: "bookEntrance",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      libraries: [],
      days: [],
      day: "",
      library: {},
      entrances: [],
      entrance: {},
    });
    onMounted(async () => {
      await init();
    });

    watch(
      () => state.library,
      async (newValue) => {
        const { data: opendays } = await getEntranceDates({ lib: newValue.id });
        state.days = opendays.map((item) => item.dat);
        state.day = state.days[0];
        const { data } = await getEntrances({
          lib: state.library.id,
          day: state.day,
        });
        state.entrances = data || [];
        state.entrances = state.entrances.filter((item) => item.status === 2);
        state.entrance = state.entrances[0] || {};
      }
    );
    watch(
      () => state.day,
      async (newValue) => {
        const { data } = await getEntrances({
          lib: state.library.id,
          day: newValue,
        });
        state.entrances = data || [];
        state.entrances = state.entrances.filter((item) => item.status === 2);
        state.entrance = state.entrances[0] || {};
      }
    );

    const init = async () => {
      try {
        const { data } = await getEntranceSchools();

        state.libraries = data || [];
        state.library = state.libraries[0];
        const { data: days } = await getEntranceDates({
          lib: state.library.id,
        });

        state.days = days.map((item) => item.dat);
        state.day = state.day || state.days[0];
      } catch (error) {
        Toast.fail(error.message);
      }
    };
    const refresh = () => {
      init();
    };

    const goBack = () => router.go(-1);
    const selectDay = (day) => {
      state.day = day;
    };
    const selectLibrary = (lib) => {
      state.library = lib;
    };
    const selectEntrance = (ent) => {
      state.entrance = ent;
    };
    const showRules = () => {
      Dialog.alert({
        title: "提示",
        allowHtml: true,
        message: state.entrance.content,
      }).then(() => {});
    };
    const applyNow = async () => {
      const { data, status, msg } = await applyEntrance(
        state.entrance.id,
        qs.stringify({
          userid: user.userid,
          access_token: user.access_token,
          id: state.entrance.id,
        })
      );
      let message = "";
      if (status === 1 && data.list) {
        message = "预约成功";
      } else {
        message = msg;
      }
      Dialog.alert({
        title: "提示",
        allowHtml: true,
        message: message,
      }).then(() => {
        goHome();
      });
    };
    const goHome = () => router.push("/index");
    return {
      goBack,
      selectDay,
      selectLibrary,
      selectEntrance,
      showRules,
      applyNow,
      refresh,
      goHome,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
</style>
